import { render, staticRenderFns } from "./exTotal.vue?vue&type=template&id=5b1e7188"
import script from "./exTotal.vue?vue&type=script&lang=ts"
export * from "./exTotal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports